import { render, staticRenderFns } from "./CV.vue?vue&type=template&id=38abd63e&scoped=true&"
import script from "./CV.vue?vue&type=script&lang=js&"
export * from "./CV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abd63e",
  null
  
)

export default component.exports